import { Box, Typography } from '@mui/material'
import { Shield01Icon } from '@untitled-theme/icons-react'

import HamburgerMenu from '@/shared/components/HamburgerMenu'

import ServiceBlock from '../components/ServiceBlock'
import {
  ADDITIONAL_SERVICES,
  ADDITIONAL_SERVICES_GOAL,
  ADDITIONAL_SERVICES_SECTION_LABEL,
  ADDITIONAL_SERVICES_SUBTITLE,
  ADDITIONAL_SERVICES_TITLE,
} from '../constants/additional-services.constants'

const AdditionalServicesPage = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        minHeight: '100vh',
        width: '100vw',
        backgroundColor: '#ffffff',
        padding: { xs: '0 24px' },
      }}
    >
      <HamburgerMenu
        sx={{
          position: 'fixed',
          top: 32,
          left: 32,
          display: { xs: 'flex', lg: 'none' },
        }}
      />

      <Box
        sx={{
          maxWidth: { xs: '100%', lg: '1125px' },
          width: '100%',
          paddingBottom: { xs: '180px', lg: '60px' },
        }}
      >
        <Box
          sx={{
            position: 'sticky',
            top: 0,
            background: 'linear-gradient(180deg, #ffffff 0%, #ffffff 90%, transparent 100%)',
            zIndex: 100,
            paddingTop: { xs: 10, lg: 5 },
            paddingBottom: 2,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 3 }}>
            <Box sx={{ display: { xs: 'none', lg: 'flex' } }}>
              <HamburgerMenu />
            </Box>
            <Typography
              component="h1"
              sx={{
                fontWeight: 600,
                fontSize: '28px',
                lineHeight: '42px',
                marginLeft: '8px',
              }}
            >
              <Box component="span" sx={{ color: '#5BC06B' }}>
                {ADDITIONAL_SERVICES_TITLE.highlight}
              </Box>{' '}
              <Box component="span">{ADDITIONAL_SERVICES_TITLE.rest}</Box>
            </Typography>
          </Box>
        </Box>

        <Box sx={{ maxWidth: { xs: '100%', lg: '900px' } }}>
          <Typography
            sx={{ fontWeight: 600, fontSize: '16px', lineHeight: '24px', marginBottom: '24px' }}
          >
            {ADDITIONAL_SERVICES_SUBTITLE}
          </Typography>

          <Typography
            sx={{ fontSize: '12px', fontWeight: 500, color: '#464A54', marginBottom: '8px' }}
          >
            {ADDITIONAL_SERVICES_SECTION_LABEL}
          </Typography>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: 'repeat(3, minmax(0, 1fr))' },
              gap: '16px',
            }}
          >
            {ADDITIONAL_SERVICES.map(service => (
              <ServiceBlock key={service.id} service={service} />
            ))}
          </Box>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '12px',
              marginTop: '24px',
              backgroundColor: '#F5F5F7',
              borderRadius: '12px',
              padding: '16px 20px',
            }}
          >
            <Box
              sx={{
                width: '32px',
                height: '32px',
                borderRadius: '8px',
                backgroundColor: '#E5F5E7',
                color: '#5BC06B',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                '& svg': { width: '18px', height: '18px' },
              }}
            >
              <Shield01Icon aria-hidden="true" />
            </Box>
            <Box>
              <Typography sx={{ fontSize: '12px', fontWeight: 400, lineHeight: '18px' }}>
                <Box component="span" sx={{ fontWeight: 600 }}>
                  {ADDITIONAL_SERVICES_GOAL.label}
                </Box>{' '}
                {ADDITIONAL_SERVICES_GOAL.text}
              </Typography>
              <Typography
                sx={{
                  fontSize: '12px',
                  fontWeight: 600,
                  lineHeight: '18px',
                  color: '#5BC06B',
                  marginTop: '4px',
                }}
              >
                {ADDITIONAL_SERVICES_GOAL.tagline}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default AdditionalServicesPage
